/* BODYSHAPE: translate display words only. Never alter bundle data, options or monetary nodes. */
(function () {
  'use strict';
  if (window.uwsKachingCopyLoaded) return;
  window.uwsKachingCopyLoaded = true;
  const rootSelector = 'kaching-bundle[product-id="15558464930136"] kaching-bundles-block[deal-block-id="a4b5f732-ddab-451e-bcab-6a149796d5e4"]';
  const copy = {
    de: ['Standardpreis', 'SPARE', 'Du sparst'],
    en: ['Standard price', 'SAVE', 'You save'],
    fr: ['Prix standard', 'ÉCONOMISEZ', 'Vous économisez'],
    es: ['Precio estándar', 'AHORRA', 'Ahorras'],
    it: ['Prezzo standard', 'RISPARMIA', 'Risparmi']
  };
  function language() {
    const m = location.pathname.match(/^\/(de|en|fr|es|it)(?:-[a-z]{2})?(?:\/|$)/i);
    return m ? m[1].toLowerCase() : 'de';
  }
  function update() {
    const words = copy[language()];
    document.querySelectorAll(rootSelector).forEach(root => {
      root.querySelectorAll('.kaching-bundles__bar-subtitle, .kaching-bundles__bar-label').forEach(el => {
        let recognized = false;
        Array.from(el.childNodes).forEach(node => {
          if (node.nodeType !== 3) return; // Preserve Svelte comments, currency spans and child controls.
          const before = node.data;
          let after = before;
          if (el.classList.contains('kaching-bundles__bar-subtitle')) {
            if (/^\s*(Standard price|Standardpreis|Prix standard|Precio estándar|Prezzo standard)\s*$/i.test(before)) {
              after = before.replace(/\S[\s\S]*\S|\S/, words[0]); recognized = true;
            } else if (/^\s*(You save|Du sparst|Vous économisez|Ahorras|Risparmi)(?=\s+[\d.,]+\s*%)/i.test(before)) {
              after = before.replace(/(You save|Du sparst|Vous économisez|Ahorras|Risparmi)/i, words[2]); recognized = true;
            }
          } else if (/^\s*(SAVE|SPARE|ÉCONOMISEZ|AHORRA|RISPARMIA)(?=\s|$)/i.test(before)) {
            after = before.replace(/(SAVE|SPARE|ÉCONOMISEZ|AHORRA|RISPARMIA)/i, words[1]); recognized = true;
          }
          if (after !== before) node.data = after;
        });
        if (recognized) { el.classList.add('notranslate'); el.setAttribute('translate', 'no'); }
      });
    });
  }
  let pending = false;
  function queue() { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; update(); }); } }
  function start() {
    update();
    new MutationObserver(records => {
      if (records.some(r => {
        const el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        return el && (el.closest(rootSelector) || (r.type === 'childList' && Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches(rootSelector) || n.querySelector(rootSelector)))));
      })) queue();
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
    window.addEventListener('popstate', queue);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
